import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Card, Stack, Button, Chip } from "@mui/material";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { STOCKS_LISTS } from "@/data/mock-data";

export function ListDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const list = STOCKS_LISTS.find((l) => l.id === id);

  if (!list) return <Typography textAlign="center" py={6}>List not found.</Typography>;

  return (
    <Box sx={{ maxWidth: 720, mx: "auto" }}>
      <Button startIcon={<ArrowBackIosNew sx={{ fontSize: 14 }} />} onClick={() => navigate("/lists")} sx={{ mb: 2 }}>
        Lists
      </Button>
      <Card sx={{ p: 3 }}>
        <Typography variant="h2" sx={{ mb: 1 }}>{list.name}</Typography>
        <Typography variant="caption" color="text.secondary">
          Created by {list.creator} · {list.tickers.length} tickers · updated {list.updatedAt}
        </Typography>
        <Box sx={{ mt: 3, display: "flex", flexWrap: "wrap", gap: 1 }}>
          {list.tickers.map((t) => (
            <Chip
              key={t}
              label={t}
              sx={{
                fontFamily: 'ui-monospace, monospace',
                fontWeight: 600,
                fontFeatureSettings: '"tnum" 1'
              }}
            />
          ))}
        </Box>
        <Stack direction="row" spacing={1.5} sx={{ mt: 3 }}>
          <Button variant="outlined">Duplicate</Button>
          <Button variant="contained">Edit tickers</Button>
        </Stack>
      </Card>
    </Box>
  );
}
